var parseFloatValue = function (value) {
    if (!value) {
        return undefined;
    }
    var parsedValue = parseFloat(value);
    return Number.isNaN(parsedValue) ? undefined : parsedValue;
};
export default parseFloatValue;
//# sourceMappingURL=parseFloatValue.js.map